import update from 'immutability-helper';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../../../shared/actionsAndConstants';
import clientsAdvancedSearch from './initialState/clientsAdvancedSearch';
import dashboardAdvancedSearch from './initialState/dashboardAdvancedSearch';
import dashboardCarriers from './initialState/dashboardCarriers';
import dashboardClients from './initialState/dashboardClients';
import dashboardContainersDamage from './initialState/dashboardContainersDamage';
import dashboardEditableFields from './initialState/dashboardEditableFields';
import dashboardDepots from './initialState/dashboardDepots';
import dashboardNotifications from './initialState/dashboardNotifications';
import dashboardOperations from './initialState/dashboardOperations';
import dashboardPilots from './initialState/dashboardPilots';
import dashboardTemplates from './initialState/dashboardTemplates';
import dashboardUsers from './initialState/dashboardUsers';
import dashboardMassUpload from './initialState/dashboardMassUpload';

const {
  app: { constants: appConstants },
  topNavbar: { constants: topNavbarConstants }
} = actionsAndConstants;

const initialState = {
  clientsAdvancedSearch,
  dashboardAdvancedSearch,
  dashboardCarriers,
  dashboardClients,
  dashboardContainersDamage,
  dashboardDepots,
  dashboardEditableFields,
  dashboardNotifications,
  dashboardOperations,
  dashboardPilots,
  dashboardTemplates,
  dashboardUsers,
  dashboardMassUpload
};

const exportTableData = (state, { meta = {}, payload = {} }) => {
  const { tableName } = meta;
  const {
    exportMode = '',
    rowIndex = null
  } = payload;
  switch (exportMode) {
    case 'excel':
      return update(state, {
        [tableName]: {
          exporting: { excel: { $set: true } }
        }
      });
    case 'pdf':
      return update(state, {
        [tableName]: {
          exporting: { pdf: { $push: [rowIndex] } }
        }
      });
    default:
      return state;
  }
};

const exportTableDataFailedOrSucceeded = (state, { meta = {}, payload = {} }) => {
  const { tableName } = meta;
  const {
    exportMode = '',
    rowIndex = null
  } = payload;
  switch (exportMode) {
    case 'excel':
      return update(state, {
        [tableName]: {
          exporting: { excel: { $set: false } }
        }
      });
    case 'pdf':
      return update(state, {
        [tableName]: {
          exporting: {
            pdf: {
              $apply(rowIndexes) {
                return rowIndexes.filter(index => index !== rowIndex);
              }
            }
          }
        }
      });
    default:
      return state;
  }
};

const loadTableData = (state, { meta = {}, payload = {} }) => {
  const { tableName } = meta;
  const {
    ajaxOptions: { queryParams = null } = {},
    event = '',
    table = null
  } = payload;
  let newProperties = { loading: { $set: true } };
  switch (event) {
    case 'tableChange':
      newProperties = { loadingTable: { $set: true } };
      break;
    default:
      break;
  }
  return update(state, {
    [tableName]: {
      error: { $set: false },
      ...queryParams && { queryParams: { $merge: queryParams } },
      ...table && { table: { $merge: table } },
      ...newProperties
    }
  });
};

const loadTableDataFailed = (state, { meta = {}, payload = {} }) => {
  const { tableName } = meta;
  const { event = '' } = payload;
  let newProperties = {
    $merge: {
      ...initialState[tableName],
      error: true
    }
  };
  switch (event) {
    case 'locationChange':
      newProperties = { $set: initialState[tableName] };
      break;
    default:
      break;
  }
  return update(state, {
    [tableName]: newProperties
  });
};

const loadTableDataSucceeded = (state, { meta = {}, payload = {} }) => {
  const { tableName } = meta;
  const {
    detalle: data = [],
    event = '',
    total = 0
  } = payload;
  let newProperties = {
    loading: false
  };
  switch (event) {
    case 'tableChange':
      newProperties = {
        loadingTable: false
      };
      break;
    default:
      break;
  }
  return update(state, {
    [tableName]: {
      $merge: {
        data,
        error: false,
        reload: false,
        total,
        ...newProperties
      }
    }
  });
};

const logoutSucceeded = () => initialState;

const reloadTableData = (state, { meta = {} }) => {
  const { tableName } = meta;
  return update(state, { [tableName]: { reload: { $set: true } } });
};

const tablesReducer = createReducer(initialState, {
  [appConstants.exportTableData]: exportTableData,
  [appConstants.exportTableDataFailed]: exportTableDataFailedOrSucceeded,
  [appConstants.exportTableDataSucceeded]: exportTableDataFailedOrSucceeded,
  [appConstants.loadTableData]: loadTableData,
  [appConstants.loadTableDataFailed]: loadTableDataFailed,
  [appConstants.loadTableDataSucceeded]: loadTableDataSucceeded,
  [appConstants.reloadTableData]: reloadTableData,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded
});

export default tablesReducer;



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/index.js